import { render } from "./PeerProfileDrawer.vue?vue&type=template&id=5d8a8ca3"
import script from "./PeerProfileDrawer.vue?vue&type=script&lang=js"
export * from "./PeerProfileDrawer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__